// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"f3-z","displaySixCardTiles":"g3-z"};